const INTERNAL_ERROR_PREFIX = /^[a-z][a-z0-9]*(?:_[a-z0-9]+)+\s+-\s+/i

export const cleanPaymentErrorMessage = (message) => {
  const trimmedMessage = message.trim()

  if (!INTERNAL_ERROR_PREFIX.test(trimmedMessage)) {
    return trimmedMessage
  }

  return trimmedMessage.replace(INTERNAL_ERROR_PREFIX, "").trim()
}

export const getPaymentErrorMessage = (error, fallback) => {
  const apiMessage = error?.response?.data?.message

  if (typeof apiMessage === "string" && apiMessage.trim()) {
    return cleanPaymentErrorMessage(apiMessage)
  }

  if (
    !error?.response &&
    !error?.request &&
    typeof error?.message === "string" &&
    error.message.trim()
  ) {
    return cleanPaymentErrorMessage(error.message)
  }

  return fallback
}
